import {createSlice} from "@reduxjs/toolkit";
import settingsApi from "../api/settings";

const now = new Date();

const settingsSlice = createSlice({
    name: 'settings',
    initialState: {
        isLoaded: false,
        currentYear: now.getFullYear(),
        currentMonth: now.getMonth() + 1,
        currentDay: now.getDate()
    },
    reducers: {
        update(state, action) {
            state.isLoaded = action.payload.isLoaded;
            state.currentYear = action.payload.currentYear;
            state.currentMonth = action.payload.currentMonth;
            state.currentDay = action.payload.currentDay;
        }
    }
});

export const settingsActions = settingsSlice.actions;

let isLoading = false;

export const fetchSettings = () => {
    return (dispatch) => {
        if (isLoading === true) {
            return;
        }
        isLoading = true;
        settingsApi.getSettings().then(response => {
            dispatch(settingsActions.update({
                isLoaded: true,
                currentYear: response.data.currentDate.year,
                currentMonth: response.data.currentDate.month,
                currentDay: response.data.currentDate.day,
            }));
        })
            .catch(() => {})
            .finally(() => {
                isLoading = false;
            });
    }
};

export default settingsSlice.reducer;